import React from 'react';
import { Box } from '@mui/material';

const MiddleContainer = ({ children }) => {
  return (
    <Box
      sx={{
        width: '97%',
        height: '95%',
        padding: '8px',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        borderRadius: '20px',
        boxShadow: 4,
        overflow: 'hidden',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      {children}
    </Box>
  );
};

export default MiddleContainer;